module.exports = __webpack_public_path__ + "c_static/img/1-3购物车.1edcbb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/1-3购物车.jpg
// module id = knaL
// module chunks = 33